export function openLaunchedApplicationHtml(html: string): void {
  const blob = new Blob([html], { type: "text/html;charset=utf-8" });
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, "_blank", "noopener,noreferrer");
  window.setTimeout(() => {
    URL.revokeObjectURL(blobUrl);
  }, 1000);
}

export function isNoLaunchGroupsMessage(message: string): boolean {
  const normalized = message.replace(/\s+/g, " ");
  return normalized.includes("No valid groups for the user in DB");
}

export function getAppLaunchFailureMeta(err: unknown): {
  httpStatus: number;
  message: string;
} {
  if (err && typeof err === "object") {
    const o = err as Record<string, unknown>;
    const code = o.httpCode;
    const msg = o.message;
    if (typeof code === "number" && typeof msg === "string") {
      return { httpStatus: code, message: msg };
    }

    const response = o.response as Record<string, unknown> | undefined;
    if (response && typeof response === "object") {
      const status = typeof response.status === "number" ? response.status : 0;
      const data = response.data;
      if (data && typeof data === "object" && "message" in data) {
        return {
          httpStatus: status,
          message: String((data as { message: unknown }).message ?? ""),
        };
      }
      if (typeof data === "string") {
        try {
          const parsed = JSON.parse(data) as { message?: string };
          return {
            httpStatus: status,
            message: parsed.message ?? data,
          };
        } catch {
          return { httpStatus: status, message: data };
        }
      }
      return { httpStatus: status, message: "" };
    }
  }
  if (err instanceof Error) {
    return { httpStatus: 0, message: err.message };
  }
  return { httpStatus: 0, message: "" };
}
